<template>
  <div>
    <PageHeader title="About"></PageHeader>
    <v-card
      outlined
      class="vcardcontent"
       v-bind:class="{ 'version-spacing': !isLoggedIn }"
    >
      <v-card-text style="color:#ffffff;" class="honeyBold">
        <p>Fanhive's mission is to make it easy to host and enter Player of a Match competitions whilst supporting the Players, the Sport Club and the Fans.</p>
        <p>Player of a Match selections have usually not included input from the Fans and are normally chosen from the winning team. Fans may be left frustrated knowing that a player in their team deserves acknowledgement for his or her efforts in a match. Fanhive was created to allow fans to have an influence over their Sport Clubs, the Teams and the Players.</p>
        <p>Fanhive enables Sport Clubs to host Player of a Match competitions. The Clubs may specify the price per entry and the entry limitation per competition (if any). Sport Clubs may also source prize sponsorships and the Sponsor logos will be associated with the respective competitions.  </p>
        <p>Fans may enter a competition, answer the sport related questions and select the Player of the Match after the match has been played. Fans may also rate the players based on their performance assessment.</p>
        <p>Fans who have both answered the questions correctly and have selected the Player of the Match will be entered into a Prize draw. The winning Fan and the *Player of the Match will receive any sponsored cash prizes and cash from the entry proceeds.</p>
        <p>Fans will earn Honey Points for their participation in Fanhive. Top Honey Point earners are listed on the platform as well as highly rated players, as determined by the Fans.</p>
        <p>*if the Sport Club deems it fit.</p>    
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'about',
  components: {
    PageHeader
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
  },
  created () {
    
  }
}
</script>